// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"18361a1c","550":"657a4c91","671":"3cca6aab","738":"96d72f91","787":"b502ac5c","874":"933658ef","878":"b5de4ffd","910":"a88b9950"}[chunkId] + ".chunk.js";
};